import { render, staticRenderFns } from "./ClinicianRespondentOverview.vue?vue&type=template&id=06b0bf48"
import script from "./ClinicianRespondentOverview.vue?vue&type=script&lang=js"
export * from "./ClinicianRespondentOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports